// src/components/Notificaciones/Notificacion.jsx
import React from "react";

const Notificacion = ({
  titulo,
  mensaje,
  tiempo,
  tipoAccion,
  isUnread,
  onClick,
  className = "",
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        relative
        w-full rounded-md mb-3 cursor-pointer shadow-sm
        ${isUnread ? "bg-[#EEF7EC]" : "bg-white"}
        px-4 py-3
        ${className}
      `}
    >
      {/* 🔵 PUNTO VERDE SI NO ESTÁ LEÍDA */}
      {isUnread && (
        <span className="absolute left-3 top-4 w-2 h-2 rounded-full bg-[#54B046]" />
      )}

      <div className="flex justify-between pl-4"> {/* desplazamos el contenido un poco a la derecha */}
        <h3 className="text-[15px] font-medium text-[#0F0F0F]">{titulo}</h3>
        <span className="text-[12px] text-[#98999A]">{tiempo}</span>
      </div>

      <p className="text-[14px] text-[#4A4A4A] leading-snug mt-1 pl-4">
        {mensaje}
      </p>

      {tipoAccion && (
        <button className="mt-3 px-3 py-2 bg-[#0F0F0F] text-white text-sm rounded-md ml-4">
          Accept
        </button>
      )}
    </div>
  );
};

export default Notificacion;
